import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { TableTypesTable } from "@msuite/utils/types";
import { client } from "@/hono";

/** Props Interface */
interface TicketTableTypeUsageProps {
	table: TableTypesTable;
	title: string;
}

export function TicketTableTypeUsage({ table, title }: TicketTableTypeUsageProps) {
	/** Hooks */

	useQuery({
		queryKey: ["table-types-usage", "ticketTypes", table],
		queryFn: async () => {
			const response = await client.organizations["table-types"][":tableTypesTable"].usage.$get({
				param: {
					tableTypesTable: table,
				},
			});
			const data = await responseHandler(response);
			return data.usage;
		},
	});

	/** Render */
	return (
		<ContentCard
			title={title}
			icon={icon("ChartBar")}
			contentClassName="h-[250px]"
		>
			{null}
		</ContentCard>
	);
}
